import cash from "@app/assets/images/onboarding/focus-cash.svg";
import clientMargin from "@app/assets/images/onboarding/focus-client-margin.svg";
import cohorts from "@app/assets/images/onboarding/focus-cohorts.svg";
import concentration from "@app/assets/images/onboarding/focus-concentration.svg";
import fees from "@app/assets/images/onboarding/focus-fees.svg";
import kpis from "@app/assets/images/onboarding/focus-kpis.svg";
import margin from "@app/assets/images/onboarding/focus-margin.svg";
import payback from "@app/assets/images/onboarding/focus-payback.svg";
import payroll from "@app/assets/images/onboarding/focus-payroll.svg";
import profit from "@app/assets/images/onboarding/focus-profit.svg";
import repeat from "@app/assets/images/onboarding/focus-repeat.svg";
import revenue from "@app/assets/images/onboarding/focus-revenue.svg";
import ruleOf40 from "@app/assets/images/onboarding/focus-rule-of-40.svg";
import runway from "@app/assets/images/onboarding/focus-runway.svg";
import spend from "@app/assets/images/onboarding/focus-spend.svg";
import trueMargin from "@app/assets/images/onboarding/focus-true-margin.svg";
import unitEconomics from "@app/assets/images/onboarding/focus-unit-economics.svg";

import { optionsFor } from "../funnel";
import { FunnelScreen } from "../screen";

import type { SavedAnswer } from "../funnel";
import type { ScreenProps } from "../types";

// By card id. An id means the same number in every set it appears in, so
// RUNWAY draws the same plane for a SaaS founder and a shop owner.
const ART: Record<string, string> = {
  KPIS: kpis,
  RUNWAY: runway,
  PAYBACK: payback,
  COHORTS: cohorts,
  SPEND: spend,
  RULE_OF_40: ruleOf40,
  CLIENT_MARGIN: clientMargin,
  CASH: cash,
  CONCENTRATION: concentration,
  MARGIN: margin,
  TRUE_MARGIN: trueMargin,
  FEES: fees,
  REPEAT: repeat,
  REVENUE: revenue,
  PAYROLL: payroll,
  PROFIT: profit,
  UNIT_ECONOMICS: unitEconomics,
};

// The one that answers back: six things CX Cash will tell them, in the words of
// the business they just said they run. funnel.ts carries all five sets and
// decides which one this lead sees. Nothing here knows what a SaaS is.
//
// One pick, and the pick advances — there is nothing to confirm.
export default function FocusStep({
  step,
  busy,
  save,
  back,
  answers,
}: ScreenProps & { answers: readonly SavedAnswer[] }) {
  const cards = optionsFor(step, answers);

  return (
    <FunnelScreen back={back} title={step.title} wide>
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
        {cards.map((card) => (
          <button
            key={card.id}
            type="button"
            onClick={() => !busy && save({ values: [card.id] })}
            className="flex flex-col rounded-xl border border-zinc-300 bg-white p-3 text-left transition-colors hover:border-zinc-400 hover:bg-zinc-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
          >
            {ART[card.id] ? (
              <img
                src={ART[card.id]}
                alt=""
                className="mb-3 block aspect-[21/10] w-full rounded-lg"
              />
            ) : (
              <span
                aria-hidden
                className="mb-3 block aspect-[21/10] w-full rounded-lg bg-zinc-100"
              />
            )}
            <span className="text-body font-semibold text-zinc-900">
              {card.name}
            </span>
            {card.subtitle && (
              <span className="mt-1.5 text-caption font-normal leading-5 text-zinc-500">
                {card.subtitle}
              </span>
            )}
          </button>
        ))}
      </div>
    </FunnelScreen>
  );
}
